<template>
    <div>
        <div class="is-clearfix has-background-white columns is-vcentered plisttable" style="min-height: 0;">
            <div class="column ">
                <span class="is-size-5">
                    [{{ plan.bno }}]
                    <strong>{{ plan.name }}</strong>
                </span>
                <span style="margin-left: 10px;">当前岗位：</span>
                <span class="is-normal tag is-link">[{{ post.code }}] {{ post.name }}</span>
                <span style="margin-left: 5px;" class="is-normal tag is-danger" @click="changePost = true" v-if="detail.state === 'Wait' || detail.state === 'Reject'">
                    [ 更换岗位 ]
                </span>
                <span style="margin-left: 10px;">招聘单位：</span>
                <span class="is-normal tag is-link ">
                    {{ post.unit }}
                </span>
                <span style="margin-left: 10px;" v-if="post.dept">用人单位：</span>
                <span class="is-normal tag is-link">
                    {{ post.dept }}
                </span>
            </div>
        </div>
        <div class="is-clearfix has-background-white columns plisttable" style="border-radius: 10px 10px 0 0;">
            <template v-if="loading">
                <div class="column"></div>
                <p class="content has-text-centered is-size-6" style="padding-top:120px;">
                    正在加载...
                </p>
                <div class="column"></div>
            </template>
            <template v-if="!loading">
                <form ref="reg_form" class="is-clearfix" style="padding:10px 5px; width: 100%;" v-html="html" autocomplete="off"></form>
            </template>
        </div>
        <div class="is-clearfix has-text-centered has-background-white columns" style="padding: 30px; border-radius: 0 0 10px 10px;">
            <div class="column"></div>
            <div class="column"></div>
            <button :class="'button is-danger is-light' + (loading ? 'is-loading' : '')" type="button" @click="doSubmit(false)" style="margin-right: 10px;" v-if="shenhe === 'auto'">仅保存，不提交审核</button>
            <button :class="'button is-link' + (loading ? 'is-loading' : '')" type="button" @click="doSubmit(true)">我已确认填写无误，提交{{ shenhe === 'auto' ? '自动' : '系统' }}审核</button>
        </div>
        <mu-dialog title="更换岗位" width="500" max-width="80%" :esc-press-close="false" :overlay-close="false" :open.sync="changePost">
            <mu-select label="请选择要更换的岗位" v-model="changeId" full-width>
                <mu-option v-for="option in posts" :key="option.id" :disabled="option.id === post.id" :label="'[' + option.code + '] ' + option.name" :value="option.id"></mu-option>
            </mu-select>
            <mu-button slot="actions" flat color="primary" @click="changePost = false">取 消</mu-button>
            <mu-button slot="actions" flat color="primary" @click="doEnterPost">确认更换</mu-button>
        </mu-dialog>
    </div>
</template>

<script>
export default {
    name: 'RecPostReg',
    data() {
        return {
            loading: true,
            detail: {},
            posts: [],
            changeId: '',
            changePost: false,
            html: '',
            plan: {},
            post: {},
            regfield: [],
            regfs: {},
            id: '',
            shenhe: ''
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.plan = JSON.parse(sessionStorage.getItem('Plan_' + this.$route.query.pid) || '{}')
            this.post = JSON.parse(sessionStorage.getItem('Post_' + this.$route.query.id) || '{}')
            this.id = this.$route.query.rid || ''
            this.shenhe = this.plan.shenhe
            this.doLoad()
        },
        alert(info) {
            this.$message.alert(info, '提示', {
                type: 'error'
            })
        },
        doEnterPost() {
            if (this.changeId === this.post.id) {
                return
            }
            this.$http
                .get('/comm/data/plan/post/detail', {
                    params: {
                        _: new Date().getTime() / 1000 / 60,
                        id: this.changeId,
                        pid: this.plan.id
                    }
                })
                .then(result => {
                    this.post = result.data
                    sessionStorage.setItem('Post_' + this.post.id, JSON.stringify(this.post))
                    this.changePost = false
                })
        },
        doLoad() {
            this.loading = true
            this.$http
                .get('/comm/data/plan/posts', {
                    params: {
                        _: new Date().getTime() / 1000 / 60,
                        id: this.$route.query.pid
                    }
                })
                .then(result => {
                    this.posts = result.datas
                })
            if (!this.plan || !this.plan.id) {
                this.$http
                    .get('/comm/data/plan/simple', {
                        params: {
                            _: new Date().getTime() / 1000 / 60,
                            id: this.$route.query.pid
                        }
                    })
                    .then(result => {
                        this.plan = result.data
                        sessionStorage.setItem('Plan_' + this.plan.id, JSON.stringify(this.plan))
                    })
            }
            if (!this.post || !this.post.id) {
                this.$http
                    .get('/comm/data/plan/post/detail', {
                        params: {
                            _: new Date().getTime() / 1000 / 60,
                            id: this.$route.query.id,
                            pid: this.$route.query.pid
                        }
                    })
                    .then(result => {
                        this.post = result.data
                        sessionStorage.setItem('Post_' + this.post.id, JSON.stringify(this.post))
                    })
            }
            this.$http
                .get('/comm/data/plan/reg/fields', {
                    params: {
                        _: new Date().getTime() / 1000 / 60,
                        id: this.$route.query.pid
                    }
                })
                .then(result => {
                    this.regfield = result.datas
                })

            this.$http
                .get('/comm/data/plan/reg/form', {
                    params: {
                        _: new Date().getTime() / 1000 / 60,
                        id: this.$route.query.pid
                    }
                })
                .then(result => {
                    this.loading = false
                    this.html = result.data.form
                    this.$nextTick(() => {
                        this.doInitFormEvent()
                        if (this.id) {
                            this.doInitReginfo()
                        }
                    })
                })
        },
        doInitFormEvent() {
            let form = this.$refs.reg_form
            let upload = form.f_s_himg_input
            upload.addEventListener('change', this.doUploadHimg)
        },
        doInitReginfo() {
            this.$http
                .get('/app/rec/reg/detail', {
                    params: {
                        _: new Date().getTime() / 1000 / 60,
                        id: this.id
                    }
                })
                .then(result => {
                    this.detail = result.data
                    this.plan = result.data.plan
                    this.post = result.data.post

                    this.regfs['f_s_himg'] = result.data.himg
                    document.getElementById('himg_view').src = result.data.himg

                    let form = this.$refs.reg_form

                    form['f_s_idno'].value = result.data.idno
                    form['f_s_mob'].value = result.data.mob
                    form['f_s_name'].value = result.data.name
                    for (let key in result.data.regf) {
                        if (key.indexOf('f_s') < 0) {
                            form[key].value = result.data.regf[key]
                        }
                    }
                })
        },
        doUploadHimg() {
            let form = this.$refs.reg_form
            let upload = form.f_s_himg_input
            let file = upload.files[0]
            if (file.type != 'image/jpeg' && file.type != 'image/png') {
                this.alert('请上传jpg或png格式照片')
                return
            }
            // if (file.size > 5120 * 1024 || file.size < 10 * 1024) {
            //     this.alert('请上传10-512KB以内的照片，并清晰无误')
            //     return
            // }
            let himgView = document.getElementById('himg_view')
            if (himgView) {
                let oldimg = himgView.src
                let fileReader = new FileReader()
                fileReader.onload = e => {
                    himgView.src = e.target.result
                    this.$http
                        .post('/comm/base/image/upload', {
                            file: file,
                            //b64: e.target.result,
                            fname: file.name,
                            type: 'Plan_Himg_' + this.plan.id
                        })
                        .then(result => {
                            if (result.code === 0) {
                                this.regfs['f_s_himg'] = result.data.url
                            } else if (oldimg) {
                                himgView.src = oldimg
                            }
                        })
                }
                fileReader.readAsDataURL(file)
            }
        },
        doSubmit(save) {
            let form = this.$refs.reg_form
            for (let i = 0; i < form.length; i++) {
                if (form[i].name.indexOf('f_') < 0 || form[i].type === 'file') {
                    continue
                }
                this.regfs[form[i].name] = form[i].value
            }
            if (this.regfs.length < 3) {
                this.alert('读取数据失败，请刷新重试')
                return
            }
            for (let i = 0; i < this.regfield.length; i++) {
                let rf = this.regfield[i]
                if (rf.ft === 'idno') {
                    if (!this.regfs[rf.id]) {
                        this.alert('请填写15位或18位身份证号')
                        return
                    }
                    if (!/^(^\d{15}$)|(^\d{17}([0-9]|X)$)$/.test(this.regfs[rf.id])) {
                        this.alert('身份证号有误，请重填')
                        return
                    }
                } else if (rf.ft === 'mobile') {
                    if (!this.regfs[rf.id]) {
                        this.lert('请填写11位手机号')
                        return
                    }
                    if (!/^1[356789]\d{9}$/.test(this.regfs[rf.id])) {
                        this.alert('手机号码有误，请重填')
                        return
                    }
                } else if (rf.ft === 'image') {
                    if (!this.regfs[rf.id]) {
                        this.alert('请上传[' + rf.lb + ']，' + rf.ht)
                        return
                    }
                } else {
                    if (rf.rq && !this.regfs[rf.id]) {
                        this.alert(rf.ht)
                        return
                    }
                    if (rf.mn && rf.mn > 0 && this.regfs[rf.id] && this.regfs[rf.id].length < rf.mn) {
                        this.alert('[' + rf.lb + '] 最少填写' + rf.mn + '个字符，您已填写' + this.regfs[rf.id].length + '个字符')
                        return
                    }
                    if (rf.mx && rf.mx > 0 && this.regfs[rf.id] && this.regfs[rf.id].length > rf.mx) {
                        this.alert('[' + rf.lb + '] 最多填写' + rf.mn + '个字符，您已填写' + this.regfs[rf.id].length + '个字符')
                        return
                    }
                }
            }

            let params = {
                id: this.id,
                pid: this.post.id,
                regf: JSON.stringify(this.regfs),
                save: save
            }

            this.submitLoading = true

            if (!save) {
                this.$alert('请注意：当前操作仅做保存处理，并不会提交系统审核,您可以随时修改，确认无误后请点击提交自动审核按钮;', '操作通知', {
                    confirmButtonText: '确定'
                }).then(() => {
                    this.$http.post('/app/rec/reg/submit', params).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.$alert('报名信息保存成功', '操作通知', {
                                confirmButtonText: '确定'
                            })
                                .then(() => {
                                    this.$router.push({ name: 'RecRegResult', query: { sno: result.data.sno, idno: result.data.idno } })
                                })
                                .catch(() => {
                                    this.$router.push({ name: 'RecRegResult', query: { sno: result.data.sno, idno: result.data.idno } })
                                })
                        }
                    })
                })
            } else {
                this.$http.post('/app/rec/reg/submit', params).then(result => {
                    this.submitLoading = false
                    if (result.code === 0) {
                        this.$alert('报名信息提交成功', '操作通知', {
                            confirmButtonText: '确定'
                        })
                            .then(() => {
                                this.$router.push({ name: 'RecRegResult', query: { sno: result.data.sno, idno: result.data.idno } })
                            })
                            .catch(() => {
                                this.$router.push({ name: 'RecRegResult', query: { sno: result.data.sno, idno: result.data.idno } })
                            })
                    }
                })
            }
        }
    }
}
</script>
